<template>
    <div class="page_container" style="padding:0;">
        <div class="container_main">
            <!-- header  -->
            <div class="page_width theme_flex row hidden-xs" >
                <div style="width: 180px;"></div>
                <div class="logo md_logo " @click="toIndex()">
                    <img src="../assets/logo.jpg" alt="">
                </div>
               
                <div class="nav_leave">
                    <div class="nav_tab" @click="showSearch">
                
                        <span class="content_icon ">
                            
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <circle cx="7" cy="7" r="5" stroke="#F3F3F3" stroke-width="1.2"></circle>
                            <line x1="11" y1="11" x2="15" y2="15" stroke="#F3F3F3" stroke-width="1.2" stroke-linecap="round"></line>
                            </svg>
                        </span>
                    </div>
                    <div class="nav_tab" @click="toLogin">
                        <!-- <span class="nav_tapbar">SIGN IN</span> -->
                        <span class="content_icon ">
                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 13C6.369 13 4.936 12.208 4.022 11C4.936 9.792 6.369 9 8 9C9.631 9 11.064 9.792 11.978 11C11.064 12.208 9.631 13 8 13ZM8 3C9.104 3 10 3.897 10 5C10 6.103 9.104 7 8 7C6.896 7 6 6.103 6 5C6 3.897 6.896 3 8 3ZM8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0Z" fill="#F3F3F3"></path>
                        </svg>
                        </span>
                    </div>
                    
                    <div class="nav_tab" @click="visible_cart=!visible_cart">
                        <el-badge :value="quantity">
                            <span class="content_icon" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.8C0 0.3584 0.349998 0 0.780884 0H1.95143C2.59776 0 3.12198 0.5376 3.12198 1.2V1.648L12.9017 2.3744C13.5838 2.4184 14.0839 3.0488 13.9883 3.7424L13.3147 8.5696C13.2743 8.85585 13.135 9.11756 12.9223 9.30679C12.7097 9.49602 12.4378 9.60011 12.1566 9.6H3.12198V11.2H10.9332C11.2402 11.1994 11.5443 11.261 11.8281 11.3812C12.112 11.5015 12.37 11.6781 12.5875 11.901C12.8049 12.1239 12.9776 12.3886 13.0956 12.6801C13.2135 12.9717 13.2745 13.2842 13.275 13.6C13.275 14.9256 12.2266 16 10.9339 16C10.5602 16.0006 10.1918 15.909 9.85957 15.7328C9.52737 15.5567 9.24107 15.3012 9.02471 14.9877C8.80834 14.6743 8.66821 14.312 8.61607 13.9314C8.56394 13.5507 8.60131 13.1627 8.72506 12.8H4.54997C4.67373 13.1627 4.7111 13.5507 4.65896 13.9314C4.60682 14.312 4.46669 14.6743 4.25033 14.9877C4.03396 15.3012 3.74767 15.5567 3.41547 15.7328C3.08326 15.909 2.71484 16.0006 2.3411 16C2.03417 16.0005 1.73015 15.9389 1.44639 15.8185C1.16263 15.6982 0.904693 15.5216 0.687302 15.2987C0.46991 15.0759 0.297324 14.8111 0.179397 14.5197C0.0614694 14.2282 0.000510269 13.9157 0 13.6C0 12.5552 0.651774 11.6656 1.56099 11.336V2.408V1.6H0.780884C0.678541 1.60021 0.57716 1.57968 0.48253 1.53959C0.387899 1.4995 0.301872 1.44064 0.22936 1.36635C0.156848 1.29206 0.0992714 1.20381 0.0599178 1.10664C0.0205642 1.00946 0.000204074 0.905267 0 0.8ZM3.12198 3.2512V8H11.8175L12.3829 3.944L3.12198 3.2512ZM10.1531 13.6C10.1531 13.1584 10.5023 12.8 10.9332 12.8C11.364 12.8 11.714 13.1584 11.714 13.6C11.714 14.0416 11.364 14.4 10.9332 14.4C10.7266 14.4002 10.5284 14.3161 10.3821 14.1661C10.2359 14.0161 10.1535 13.8125 10.1531 13.6ZM1.56099 13.6C1.56099 13.1584 1.91099 12.8 2.34188 12.8C2.77276 12.8 3.12198 13.1584 3.12198 13.6C3.12198 14.0416 2.77276 14.4 2.34188 14.4C2.23953 14.4002 2.13815 14.3797 2.04352 14.3396C1.94889 14.2995 1.86286 14.2406 1.79035 14.1663C1.71784 14.0921 1.66026 14.0038 1.62091 13.9066C1.58156 13.8095 1.5612 13.7053 1.56099 13.6Z" fill="#F3F3F3"></path>
                                </svg>
                            </span>
                        </el-badge>
                        <!-- <span class="nav_tapbar" style="margin-right:5px;">MY BAG</span>
                        <span class="">({{ quantity }})</span> -->
                    </div>
                </div>
            </div>
            <div class="header_menu row hidden-xs ">
                <div class="header_menu_tab cursor" v-for="(v,index) in menu_list" :key="index" @click="toCategory(v)">  {{v}} </div>
            </div>
            <!-- header--mobile -->
             <div class="header_main theme_flex row header_mobile visible-xs" >              
                <img class="logo" src="../assets/logo.jpg" alt=""  @click="toCategory('new')">      
                <div class="nav_leave_mobile right_option">     
                    <div class="nav_tab cursor" @click="visible_cart=!visible_cart">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0.8C0 0.3584 0.349998 0 0.780884 0H1.95143C2.59776 0 3.12198 0.5376 3.12198 1.2V1.648L12.9017 2.3744C13.5838 2.4184 14.0839 3.0488 13.9883 3.7424L13.3147 8.5696C13.2743 8.85585 13.135 9.11756 12.9223 9.30679C12.7097 9.49602 12.4378 9.60011 12.1566 9.6H3.12198V11.2H10.9332C11.2402 11.1994 11.5443 11.261 11.8281 11.3812C12.112 11.5015 12.37 11.6781 12.5875 11.901C12.8049 12.1239 12.9776 12.3886 13.0956 12.6801C13.2135 12.9717 13.2745 13.2842 13.275 13.6C13.275 14.9256 12.2266 16 10.9339 16C10.5602 16.0006 10.1918 15.909 9.85957 15.7328C9.52737 15.5567 9.24107 15.3012 9.02471 14.9877C8.80834 14.6743 8.66821 14.312 8.61607 13.9314C8.56394 13.5507 8.60131 13.1627 8.72506 12.8H4.54997C4.67373 13.1627 4.7111 13.5507 4.65896 13.9314C4.60682 14.312 4.46669 14.6743 4.25033 14.9877C4.03396 15.3012 3.74767 15.5567 3.41547 15.7328C3.08326 15.909 2.71484 16.0006 2.3411 16C2.03417 16.0005 1.73015 15.9389 1.44639 15.8185C1.16263 15.6982 0.904693 15.5216 0.687302 15.2987C0.46991 15.0759 0.297324 14.8111 0.179397 14.5197C0.0614694 14.2282 0.000510269 13.9157 0 13.6C0 12.5552 0.651774 11.6656 1.56099 11.336V2.408V1.6H0.780884C0.678541 1.60021 0.57716 1.57968 0.48253 1.53959C0.387899 1.4995 0.301872 1.44064 0.22936 1.36635C0.156848 1.29206 0.0992714 1.20381 0.0599178 1.10664C0.0205642 1.00946 0.000204074 0.905267 0 0.8ZM3.12198 3.2512V8H11.8175L12.3829 3.944L3.12198 3.2512ZM10.1531 13.6C10.1531 13.1584 10.5023 12.8 10.9332 12.8C11.364 12.8 11.714 13.1584 11.714 13.6C11.714 14.0416 11.364 14.4 10.9332 14.4C10.7266 14.4002 10.5284 14.3161 10.3821 14.1661C10.2359 14.0161 10.1535 13.8125 10.1531 13.6ZM1.56099 13.6C1.56099 13.1584 1.91099 12.8 2.34188 12.8C2.77276 12.8 3.12198 13.1584 3.12198 13.6C3.12198 14.0416 2.77276 14.4 2.34188 14.4C2.23953 14.4002 2.13815 14.3797 2.04352 14.3396C1.94889 14.2995 1.86286 14.2406 1.79035 14.1663C1.71784 14.0921 1.66026 14.0038 1.62091 13.9066C1.58156 13.8095 1.5612 13.7053 1.56099 13.6Z" fill="#F3F3F3"></path>
                                </svg>
                    </div>
                </div>
                 <div class="nav_leave_mobile left_option">     
                    <div class="nav_tab cursor"  @click="visible_menu=!visible_menu">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.2 9H0.8C0.587827 9 0.384344 8.89464 0.234315 8.70711C0.0842855 8.51957 0 8.26522 0 8C0 7.73478 0.0842855 7.48043 0.234315 7.29289C0.384344 7.10536 0.587827 7 0.8 7H15.2C15.4122 7 15.6157 7.10536 15.7657 7.29289C15.9157 7.48043 16 7.73478 16 8C16 8.26522 15.9157 8.51957 15.7657 8.70711C15.6157 8.89464 15.4122 9 15.2 9ZM15.2 2H0.8C0.587827 2 0.384344 1.89464 0.234315 1.70711C0.0842855 1.51957 0 1.26522 0 1C0 0.734784 0.0842855 0.48043 0.234315 0.292893C0.384344 0.105357 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.105357 15.7657 0.292893C15.9157 0.48043 16 0.734784 16 1C16 1.26522 15.9157 1.51957 15.7657 1.70711C15.6157 1.89464 15.4122 2 15.2 2ZM15.2 16H0.8C0.587827 16 0.384344 15.8946 0.234315 15.7071C0.0842855 15.5196 0 15.2652 0 15C0 14.7348 0.0842855 14.4804 0.234315 14.2929C0.384344 14.1054 0.587827 14 0.8 14H15.2C15.4122 14 15.6157 14.1054 15.7657 14.2929C15.9157 14.4804 16 14.7348 16 15C16 15.2652 15.9157 15.5196 15.7657 15.7071C15.6157 15.8946 15.4122 16 15.2 16Z" fill="white"></path>
                        </svg>
          
                    </div>
                    <div class="nav_tab cursor " style="margin-left:15px;" @click="showSearch">
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 13C6.369 13 4.936 12.208 4.022 11C4.936 9.792 6.369 9 8 9C9.631 9 11.064 9.792 11.978 11C11.064 12.208 9.631 13 8 13ZM8 3C9.104 3 10 3.897 10 5C10 6.103 9.104 7 8 7C6.896 7 6 6.103 6 5C6 3.897 6.896 3 8 3ZM8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0Z" fill="#F3F3F3"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <!-- menu -->          
            <!-- search -->
            <div class="search_container page_container ">
                <div class="search_model"></div>
                <div class="search_content">
                    <input type="search" name="" v-model="search" placeholder="Search" class="search_inp default_btn" @keydown="ev_search($event)">
                     <span class="content_icon search_remove" @click="hideSearch">
                        <svg t="1682385763004" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10585" width="18" height="18"><path d="M576 512l277.333333 277.333333-64 64-277.333333-277.333333L234.666667 853.333333 170.666667 789.333333l277.333333-277.333333L170.666667 234.666667 234.666667 170.666667l277.333333 277.333333L789.333333 170.666667 853.333333 234.666667 576 512z" fill="#000" p-id="10586"></path></svg>
                    </span>
                    <span class="search_icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
                            <circle cx="7" cy="7" r="5" stroke="#000000" stroke-width="1.2"></circle>
                            <line x1="11" y1="11" x2="15" y2="15" stroke="#000000" stroke-width="1.2" stroke-linecap="round"></line>
                            </svg>
                    </span>
                </input>
                   
                </div>
            </div>
            <!-- mobile menu -->
            <div class="header_menu_mobile visible-xs">
                <el-drawer 
                    size="50%"
                    title=""
                    :visible.sync="visible_menu"
                     direction="ltr"
                    :with-header="false">
                        <div class="drawer_header" @click="toLogin">
                            <div class="pull-left cursor"> <span class="mini_login glyphicon glyphicon-user"></span> sign in</div>
                        </div>
                        <!-- <div class="shop_top">
                            <img src="https://cdn.shopifycdn.net/s/files/1/2483/6632/files/NewTopMegamenu-Mobile_540x.jpg?v=1679974527" alt="">
                        </div> -->
                        <div class="header_menu_tab cursor" v-for="(v,index) in menu_list" :key="index" @click="toCategory(v)">  {{v}}  <span class="glyphicon glyphicon-menu-right"></span></div>
                </el-drawer>
            </div>
            <!-- cart drawer -->
            <div class="cart_drawer">
                <el-drawer
                    title=""
                    :size="sliderCartWidth"
                    :visible.sync="visible_cart"                
                    direction="rtl">        
                    <div class="slider_cart" v-if="goodsCart.length>0">
                        <div class="cart_theme" v-for="(v,index) in goodsCart" :key = 'index'>
                            <div class="theme_left">
                                <div class="cart_title">{{ v.title }}</div>
                                <div class="cart_option amount">${{ v.amount }}</div>
                                <div class="cart_option">
                                    <div class="cart_label">color:</div>{{ v.color_name }}
                                </div>
                                <div class="cart_option" style="text-transform: uppercase;">
                                    <div class="cart_label" >size:</div>{{ v.size }}
                                </div>
                                <div class="cart_option">
                                    <div class="quantity">
                                        <button class="quantity_change" @click="updateCount('cut',v,index)">-</button>
                                        <input class="quantity_number" type="number" :value="v.count">
                                        <button class="quantity_change" @click="updateCount('add',v,index)">+</button>
                                        <div class="cart_remove content_icon cursor" @click="updateCount('delete',v,index)">
                                           <svg t="1680591329878" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2816" data-darkreader-inline-fill="" width="16" height="16"><path d="M928.16 144H736V64a32 32 0 0 0-32-32H320a32 32 0 0 0-32 32v80H95.84a32 32 0 0 0 0 64H129.6l77.92 698.656A96 96 0 0 0 302.912 992h418.144a96.032 96.032 0 0 0 95.424-85.344L894.4 208h33.728a32 32 0 0 0 0.032-64zM352 96h320v48H352V96z m400.896 803.552a32 32 0 0 1-31.808 28.448H302.912a32 32 0 0 1-31.808-28.448L193.984 208h636.032l-77.12 691.552z" p-id="2817" fill="#231F20" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#131210;"></path><path d="M608 820.928a32 32 0 0 0 32-32V319.104a32 32 0 0 0-64 0v469.824a32 32 0 0 0 32 32zM432 820.928a32 32 0 0 0 32-32V319.104a32 32 0 0 0-64 0v469.824a32 32 0 0 0 32 32z" p-id="2818" fill="#231F20" data-darkreader-inline-fill="" style="--darkreader-inline-fill:#131210;"></path></svg>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="cart_right ">
                               <img :src="v.images[0].src" alt="">
                            </div>
                        </div>
                        <div class="cart_totals">
                            <div class="pull-left cart_in_cart">({{ quantity }}) Items in bag</div>
                            <div class="pull-right cart_subtotal">
                                subtotal：
                                <span>${{ total }}</span>
                            </div>
                        </div>
                        <div class="cart_checkout">
                            <button class="tree_button btn_primary" @click="toCart">
                              Checkout
                            </button>
                        </div>   
                    </div>
                    <div class="slider_cart_empty" v-else>
                        <div>Your cart is currently empty.</div>
                        <p>We've had a good look but there's nothing in here.</p>

                    </div>
                </el-drawer>     
            </div>
        </div>
    </div>
</template>

<script>
 import $ from 'jquery'
 import { getToken } from '@/utils/auth'
export default {
    name: 'ASTRHeader',
    inject:['reload'],
   
    data() {
        return {
            menu_list:['new','dresses','tops','bottoms'],
            visible_menu:false,
            visible_cart:false,
            clientWidth:document.body.clientWidth,
            sliderCartWidth:410,
            signIn_flag:false,
            search:'',
        
        };
    }, 

    mounted() {
       let that = this;
        window.onresize =() =>{
        return (()=>{
        window.clientWidth = document.body.clientWidth;
        that.clientWidth = window.clientWidth;
        if(that.clientWidth>768){
            that.sliderCartWidth = 410
        }
        if(that.clientWidth<=768){
            that.sliderCartWidth = 320
        }
        })()
       };
    },
    
    methods: {
        toCategory(path) {
            this.visible_menu = false
            this.$router.push('/category?categoryName='+path)
              this.reload()
              return
            // if(path == 'new'){
            //  this.$router.push('/index')
            //   return
            // }else{
            //   this.$router.push('/category?categoryName='+path)
            //   this.reload()
            // }         
        },
        toCart(){
            this.visible_cart = false
            this.$store.commit('getGoods_cart_drawer',false)
            this.$router.push('/cart')
        },
        toLogin(){
            if(!getToken()){
                this.$router.push('/login')
                return
            }
            this.$router.push('/account')
        },
        toIndex(){
            this.$router.push('/index')
        },
        toRegister() {
            this.$router.push('/register')
        },
        showSearch(){
         
            $('.search_container').css({'display': 'block','opacity':'1'})
            // $('.header_menu').css('display','none')
        },
        hideSearch(){
            $('.search_container').css({'display': 'none','opacity':'0'})
            $('.header_menu').css('display','flex')
        },    
        updateCount(type,item,index){
           this.$store.dispatch('updateItemCount',{type:type,item:item,index:index})
            
        },
        ev_search(ev){
            if(ev.keyCode == 13) {  //键盘回车的编码是13
                console.log('search',this.search)
                if(this.search){
                    this.hideSearch()
                    this.$router.push('/category?search='+this.search)
                    this.reload()
                }
            }
		},
      
        
   },
   computed: {
    goodsCart() { return this.$store.state.goods_cart},
    quantity(){return this.$store.state.goods_cart_count },
    total(){ return this.$store.state.goods_cart_total},
    // visible_cart(){ return this.$store.Goods_cart_drawer}
   },
   watch:{
    clientWidth(newVal,oldVal){
      if(newVal>768){
            this.sliderCartWidth = 410
        }
        if(newVal<=768){
            this.sliderCartWidth = 320
        }
    },
    // '$store.state.goods_cart_count':{
    //     deep: true,
    //     handler(nv,ov){
    //         this.quantity = nv
    //     }
    // },
    '$store.state.goods_cart_drawer':{
        deep: true,
        handler(nv,ov){
            this.visible_cart = nv
            let that = this
            setTimeout(() => {
                that.visible_cart = false
               that.$store.commit('setGoods_cart_drawer',false)
            }, 2000);
        }
    }

   }
};
</script>

<style lang="scss" scoped>
.logo{
    max-width: 100%;
    width:160px;
    // position: absolute;
    // left: 0;
    // margin: 0px auto 0;
    // right: 0;
    // width: 200px;
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    margin: 0 auto;
}
.md_logo{
    left: 30px;
    right: unset;
}
.header_mobile{
    // height:115px;
}
.theme_flex{
    justify-content: flex-end;
    align-items: center;
    background-color: #000;
   padding-top:20px;
  .nav_leave{
    font-size:14px;
    
    display: flex;
    align-items: center;
    justify-content: center;
    .nav_tab{
        padding-left:40px;
        display: flex;
        color:#fff;
        font-weight:500;
        cursor: pointer;
      .nav_tapbar{
        margin:0 15px;
      }
    }
  }
}
.header_menu{
    position: relative;
    // height:50px;
    font-size:14px;
    color:#fff;
    flex:1;
    padding: 0 20px;
    background-color: #000;
    // border-top:1px solid #dedede;
    // border-bottom:1px solid #dedede;
    padding:10px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .25s ease-in-out;
    .header_menu_tab{
        
        text-transform: uppercase;
        // letter-spacing: 1px;
        transition: all .25s;
        font-weight: 600;
        height:100%;
        line-height:50px;
        position: relative;
        display: flex;
        color:#fff;
        font-size:14px;
        margin:0 16px;
        &::after{
            content:'';
			display:block;
			/*开始时候下划线的宽度为100%*/
			width:100%;
			height:2px;
			position:absolute;
			bottom:0px;
			background:#000;
			transition:all 0.3s ease-in-out;
			/*通过transform的缩放scale来让初始时x轴为0*/
			transform: scale3d(0,1,1);
			/*将坐标原点移到元素的中间，以原点为中心进行缩放*/
        }
        &:hover{
            &::after{
                /*鼠标经过时还原到正常比例*/
		    	transform:scale3d(1,1,1);
            }
        }
    }

    
}
.search_container{
    // max-width:1300px;
    margin:0 auto;
    position: relative;
    height:50px;
    display: none;
    opacity: 0;
    background-color: #000;
    transition: opacity .25s ease-in-out;
    .search_model{
        background:#fff;
        opacity: 0.2;
        z-index: 8;
        position: fixed;
        left:0;
        right:0;
        top:0;
        bottom:0;
    }
    .search_content{
        display: flex;
        z-index: 999;
        position: absolute;
        bottom:10px;
        left:0;
        right:0;
        transition: opacity .25s ease-in-out;
        max-width:1300px;
        margin:0 auto;
        .search_inp{
            position: relative;
            flex:1;
            border-radius: 0px;
            background-color: #fff;
            border: 1px solid transparent;
            height:44px;
            padding-right:44px;
            padding-left:44px;
            transition: background-color .25s ease-in-out,border .25s ease-in-out;
            &:focus{
                background-color:#fff;
                border:1px solid #000;
                box-shadow: 0 0 0 1px #000;
               
            }
        }
        .search_remove{
            position: absolute;
            right: 0;
            color:#000;
            width:44px;
            height:44px;
            background-color:transparent;
            // border-radius: 0px;
            line-height: 44px;
            // border:1px solid transparent;
            &:hover{
               opacity: 0.8;
                // border:1px solid #000;
            }

        }
        .search_icon{
            width:44px;
            height:44px;
             line-height: 52px;
            position: absolute;
            left:0;
        }
    }
}
.header_menu_mobile{
    .header_menu_tab{
        color:#000;
        padding: 0 20px;
        margin-bottom:18px;
        text-transform: uppercase;
        text-align: left;
        font-size:16px;
        letter-spacing: 1px;
        display: flex;
        justify-content:space-between;
        align-items: center;
        width:100%;
        >span{
            font-size:14px;
            margin-left:10px;
        }
    }
    .shop_top{
        padding:20px;
        
    }
}
.drawer_header{
    padding:20px 20px 0;
    height:40px;
    font-size:12px;
    text-transform:uppercase;
    color:#000;
    .mini_login{
        font-size:14px;
        margin-right:5px;
        margin-bottom:30px;
    }
}
.cart_drawer{
    .slider_cart{
        padding:20px;
        .cart_theme{
            display: flex;
            line-height:1.5;
            .theme_left{
                flex:1;
                margin-left:20px;
                 color:#000;
                 text-align: left;
                .cart_title{
                    font-size:14px;
                    // text-transform: uppercase;
                    // letter-spacing:1px;
                    // transform: scale(0.8);
                    transform-origin: 0 0;
                    font-weight: 600;
                }
                .cart_option{
                    font-size:13px;
                    display: flex;
                    transform: scale(0.8);
                    transform-origin: 0 0;
                    margin:3px 0;
                    .cart_label{
                        font-weight: 600;
                        text-transform: uppercase;
                        margin-right:5px;

                    }
                }
            }
            .cart_right{
                width:70px;
                >img{
                    width:100%;
                    height:auto;
                }
            }
            .cart_remove{
                margin-left:20px;
            }
        }
        .cart_totals{
            clear: both;
            overflow: hidden;
            color:#000;
            margin-top:30px;
            padding:10px 0;
            border-top:1px solid #979797;
            border-bottom:1px solid #979797;
            .cart_in_cart{
                text-decoration: underline;
                padding-left:10px;

            }
            .cart_subtotal{
                padding-right:12px;
                text-transform: uppercase;
                font-weight: 600;
                >span{
                    min-width:60px;
                    margin-left:10px;

                }
            }
        }
        .cart_checkout{
            width:100%;
            margin-top:20px;
            text-transform: uppercase;
        }
    }
    .slider_cart_empty{
        padding:20px;     
        letter-spacing: 1.5px;
        >div{
            font-size:18px;
        }
    }
}
.min_login{
    height:80px;
    position:absolute;
    bottom:-81px;
    left:0%;
    right:0%;
    z-index:99;
    background-color:#fff;
    .inp_content{
        display: flex;
        justify-content: center;
        align-items: center;
        width:80%;
        margin-left:10%;
        margin-right:10%;
        margin-top:20px;
        font-size:16px;
        .block_text{
            margin:0 10px;

        }
    }
}
// element-ui drawer
/deep/ .el-drawer__header{
    margin-bottom:0;
}


</style>


// WEBPACK FOOTER //
// src/components/header.vue